export default class CreateCounterError extends Error {

}
